/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ProblemDetail,
  UserCreate,
  UserOut,
  UserUpdate
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType , BodyType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Сотрудники (включая отключённых)
 */
export const usersListUsers = (
    
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<UserOut[]>(
      {url: `/api/v1/users`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getUsersListUsersQueryKey = () => {
    return [
    `/api/v1/users`
    ] as const;
    }

    
export const getUsersListUsersQueryOptions = <TData = Awaited<ReturnType<typeof usersListUsers>>, TError = ErrorType<ProblemDetail>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListUsers>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersListUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersListUsers>>> = ({ signal }) => usersListUsers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersListUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof usersListUsers>>>
export type UsersListUsersQueryError = ErrorType<ProblemDetail>


export function useUsersListUsers<TData = Awaited<ReturnType<typeof usersListUsers>>, TError = ErrorType<ProblemDetail>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersListUsers>>,
          TError,
          Awaited<ReturnType<typeof usersListUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersListUsers<TData = Awaited<ReturnType<typeof usersListUsers>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersListUsers>>,
          TError,
          Awaited<ReturnType<typeof usersListUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersListUsers<TData = Awaited<ReturnType<typeof usersListUsers>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListUsers>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сотрудники (включая отключённых)
 */

export function useUsersListUsers<TData = Awaited<ReturnType<typeof usersListUsers>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListUsers>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersListUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create User
 */
export const usersCreateUser = (
    userCreate: BodyType<UserCreate>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<UserOut>(
      {url: `/api/v1/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userCreate, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getUsersCreateUserMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersCreateUser>>, TError,{data: BodyType<UserCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof usersCreateUser>>, TError,{data: BodyType<UserCreate>}, TContext> => {

const mutationKey = ['usersCreateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersCreateUser>>, {data: BodyType<UserCreate>}> = (props) => {
          const {data} = props ?? {};

          return  usersCreateUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersCreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof usersCreateUser>>>
    export type UsersCreateUserMutationBody = BodyType<UserCreate>
    export type UsersCreateUserMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Create User
 */
export const useUsersCreateUser = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersCreateUser>>, TError,{data: BodyType<UserCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersCreateUser>>,
        TError,
        {data: BodyType<UserCreate>},
        TContext
      > => {

      const mutationOptions = getUsersCreateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update User
 */
export const usersUpdateUser = (
    userId: number,
    userUpdate: BodyType<UserUpdate>,
 options?: SecondParameter<typeof apiRequest>,) => {
      
      
      return apiRequest<UserOut>(
      {url: `/api/v1/users/${userId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userUpdate
    },
      options);
    }
  


export const getUsersUpdateUserMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdateUser>>, TError,{userId: number;data: BodyType<UserUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof usersUpdateUser>>, TError,{userId: number;data: BodyType<UserUpdate>}, TContext> => {

const mutationKey = ['usersUpdateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersUpdateUser>>, {userId: number;data: BodyType<UserUpdate>}> = (props) => {
          const {userId,data} = props ?? {};

          return  usersUpdateUser(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersUpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof usersUpdateUser>>>
    export type UsersUpdateUserMutationBody = BodyType<UserUpdate>
    export type UsersUpdateUserMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Update User
 */
export const useUsersUpdateUser = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdateUser>>, TError,{userId: number;data: BodyType<UserUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersUpdateUser>>,
        TError,
        {userId: number;data: BodyType<UserUpdate>},
        TContext
      > => {

      const mutationOptions = getUsersUpdateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    